import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ServerResponse } from '../models/types';
import { GetLocalForageConFigService } from "./getLocalForage.service";
import { async } from 'q';
import * as localForage from 'localforage';
import { SuKienGia } from "../models/sukiengia.model";
import { Store } from "@ngrx/store";
import { JWTService } from "./JWTService";

@Injectable()
export class SuKienGiaService {
  dsSuKienGia: Array<SuKienGia> = new Array<SuKienGia>();
  url: any
  constructor(
    private http: HttpClient,
    private storeSKG: Store<SuKienGia>,
    private jwtService: JWTService,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
  }


  async getSuKienGia(value: string) {
    return this.http.post(this.url + 'api/SuKienGia/getSuKienGia', { STORE: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.dsSuKienGia = result[0].data;
          console.log(result[0].data);
          const str = this.jwtService.enCryptData(this.dsSuKienGia);
          this.storeSKG.dispatch({ type: 'INIT_SuKienGia', skg: this.dsSuKienGia });
          this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_dsSKG', str);
            });
          console.log('getSuKienGia');
          return Promise.resolve(this.dsSuKienGia);
        } else {
          //throw new Error(result[0].message)
          return Promise.reject(null);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sukiengia.service.ts